import { Box, Container, Typography, Card, Fade } from "@mui/material";
import Navbar from "../../components/navbar/NavBar";
import Footer from "../../components/navbar/Footer";

const BlogPost2 = () => {
  const post = {
    title: "Transform Your Property Planning with AI-Powered Vastu Analysis",
    date: "February 13, 2025",
    readTime: "5 min read",
    author: "Er. Santos Pudasaini",
    content: [
      {
        type: "paragraph",
        content:
          "Imagine being able to design your perfect home with the ancient wisdom of Vastu Shastra, powered by cutting-edge technology. Our revolutionary property planning system brings this vision to life, offering an intuitive, step-by-step journey from initial property mapping to comprehensive Vastu analysis.",
      },
      {
        type: "heading",
        content: "Your Journey Begins: Interactive Property Mapping",
      },
      {
        type: "paragraph",
        content:
          "The magic starts the moment you create your property profile. Our system seamlessly integrates with advanced mapping technology to transport you to your property's location. Here's where the real innovation begins - you can precisely pin your property's boundary on an interactive map, creating a digital footprint of your future haven.",
      },
      {
        type: "heading",
        content: "Flexible Design Options: Map or Upload",
      },
      {
        type: "paragraph",
        content:
          "We understand that every property owner has unique needs. That's why we've created two powerful approaches to property planning:\n\n1. Direct Interaction: Drag and drop elements directly within your marked boundary on the map, experimenting with different layouts in real-time.\n\n2. Site Plan Integration: Already have a site plan? Simply upload it and sync two reference points between your map boundary and site plan. Our advanced algorithm automatically calculates your property's true north orientation, ensuring perfect Vastu alignment.",
      },
      {
        type: "heading",
        content: "Smart Site Planning with Automated North Calculation",
      },
      {
        type: "paragraph",
        content:
          "Once your property is oriented correctly, you're transported to an intelligent site planning interface. Here, the calculated rotation ensures perfect alignment with cardinal directions - a crucial aspect of Vastu Shastra. The interface maintains the same intuitive drag-and-drop functionality, allowing you to place and adjust elements while receiving real-time Vastu feedback.",
      },
      {
        type: "heading",
        content: "Comprehensive Vastu Analysis and Reporting",
      },
      {
        type: "paragraph",
        content:
          "The culmination of your journey is a detailed Vastu report that analyzes every aspect of your design. But we don't stop there - we believe in giving you complete control:\n\n• Edit and customize your reports to match your specific needs\n• Provide feedback that helps us improve our recommendations\n• Download professional-quality reports for sharing with architects or contractors\n• Track changes and iterations as your design evolves",
      },
      {
        type: "heading",
        content: "Why This Matters",
      },
      {
        type: "paragraph",
        content:
          "In today's fast-paced world, combining ancient Vastu wisdom with modern technology isn't just convenient - it's essential. Our system bridges this gap, offering precision, flexibility, and deep insights that would take weeks to obtain through traditional methods. Whether you're building a new home or optimizing an existing space, our platform ensures your property aligns perfectly with Vastu principles while meeting contemporary needs.",
      },
    ],
    image:
      "https://res.cloudinary.com/duaz5kg1m/image/upload/v1739479265/vastushastra001_f1ivon.jpg",
  };

  return (
    <Box sx={{ background: "#ffffff", minHeight: "100vh", color: "#333333" }}>
      <Navbar />

      <Container sx={{ pt: 15, pb: 8 }}>
        <Fade in timeout={1000}>
          <Card sx={{ p: { xs: 3, md: 6 }, borderRadius: 4 }}>
            <Typography variant="subtitle1" sx={{ color: "#666666", mb: 2 }}>
              {post.date} · {post.readTime} · By {post.author}
            </Typography>

            <Typography
              variant="h2"
              component="h1"
              gutterBottom
              sx={{
                color: "#bb0000",
                fontWeight: 700,
                position: "relative",
                mb: 4,
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -8,
                  left: 0,
                  width: "80px",
                  height: "4px",
                  background: "#bb0000",
                  borderRadius: "2px",
                },
              }}
            >
              {post.title}
            </Typography>

            <Box
              component="img"
              src={post.image}
              alt={post.title}
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: 2,
                mb: 4,
              }}
            />

            {post.content.map((section, index) => (
              <Box key={index} sx={{ mb: 4 }}>
                {section.type === "heading" ? (
                  <Typography
                    variant="h4"
                    component="h2"
                    gutterBottom
                    sx={{
                      color: "#bb0000",
                      fontWeight: 600,
                      mt: 4,
                      mb: 3,
                    }}
                  >
                    {section.content}
                  </Typography>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#555555",
                      lineHeight: 1.8,
                      fontSize: "1.1rem",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {section.content}
                  </Typography>
                )}
              </Box>
            ))}
          </Card>
        </Fade>
      </Container>
      <Footer />
    </Box>
  );
};

export default BlogPost2;
